const Pages = {
  LABEL_MAX_LENGTH: 500,
  LABEL_MIN_LENGTH: 2,
  TEXT_EDITOR_MAX_ATTACHMENTS: 10,
  LINK_SHORTENER_NAME_MAX_CHARS: 100,
  GOOGLE_MY_BUSINESS_MANUAL_PAGE_CREATION_ENABLED: false,
};

export default Pages;
